import { getStorage, setStorage } from '@/utils/storage'
import {
  STORAGE_HISTORY_LIST,
  STORAGE_CITY_HISTORY_LIST,
  STORAGE_CURRENT_TRAVEL,
  STORAGE_TRAVEL_TYPE,
  STORAGE_ERROR_MSG,
} from '@/utils/train-storage';

export default {
  /**
   * @description: 存储差旅单信息
   */
  setTrip(state, payload) {
    const { requisition_list = [], institution_list = [] } = payload || {}
    state.requisition_list = requisition_list
    state.institution_list = institution_list
    const travelList = requisition_list
      .map(item => {
        return item?.trip_list?.map?.(col => {
          return { ...item, ...col }
        })
      })
      .flat()
    state.travelList = travelList
    const currentTravel =
      (getStorage('es_public_institution_id') &&
        travelList?.find?.(
          item =>
            item?.institution_id === getStorage('es_public_institution_id')
        )) ||
      institution_list?.find?.(
        item => item?.institution_id === getStorage('es_public_institution_id')
      ) ||
      travelList?.find?.(item => item?.default_selected) ||
      travelList?.[0]
    state.currentTravel = currentTravel
    state.travelInfoContent =
      currentTravel?.trip_config_content?.[0]?.config_list || []
    const start_city = currentTravel?.start_city
    const end_city = currentTravel?.end_city_list?.[0]
    if (travelList?.length) {
      // 有差旅单
      if (start_city && end_city) {
        state.currentFromCity = {
          ...start_city,
          subName: start_city.name,
          precise_search: '0'
        }
        state.currentToCity = {
          ...end_city,
          subName: end_city.name,
          precise_search: '0'
        }
      }
    }
  },


  /**
   * @method 切换差旅制度
   */
  setCurrentTravel(state, payload) {
    const currentTravel = payload
    state.currentTravel = currentTravel
    state.travelInfoContent =
      currentTravel?.trip_config_content?.[0]?.config_list || []
    const start_city = currentTravel?.start_city
    const end_city = currentTravel?.end_city_list?.[0]
    if (start_city && end_city) {
      state.currentFromCity = {
        ...start_city,
        subName: start_city.name,
        precise_search: '0'
      }
      state.currentToCity = {
        ...end_city,
        subName: end_city.name,
        precise_search: '0'
      }
    }
    setStorage({ key: STORAGE_CURRENT_TRAVEL, data: currentTravel })
  },
  setErrorMsg(state, payload) {
    state.errorMsg = [...payload]
    setStorage({ key: STORAGE_ERROR_MSG, data: [...payload] })
  },

  /**
   * @description: 搜索城市列表
   */
  setSearchedCity(state, payload) {
    state.searchedCityList = payload?.stations
  },


  /**
   * @description: 存储 selectCityList
   */
  changeSelectCityList(state, payload) {
    const { type, data } = payload
    state[type] = data
  },

  /**
   * @description: 存储日期
   */
  setTravelDate(state, payload) {
    state.selectDate = payload
  },

  setHistoryList(state, payload) {
    if (!payload?.[0]?.name || !payload?.[1]?.name) {
      state.historyList = []
      // todo
      setStorage({ key: STORAGE_HISTORY_LIST, data: [] })
      return
    }
    let updateHistoryList = JSON.parse(JSON.stringify(state.historyList))
    const preCheck = updateHistoryList.find(
      item =>
        item[0].name === payload[0].name &&
        item[0].precise_search === payload[0].precise_search &&
        item[1].name === payload[1].name &&
        item[1].precise_search === payload[1].precise_search
    )
    if (preCheck) {
      updateHistoryList = updateHistoryList.filter(
        item =>
          item[0].name !== payload[0].name ||
          item[0].precise_search !== payload[0].precise_search ||
          item[1].name !== payload[1].name ||
          item[1].precise_search !== payload[1].precise_search
      )
      updateHistoryList.unshift(payload)
    } else {
      updateHistoryList.unshift(payload)
      if (updateHistoryList.length > 6) {
        updateHistoryList.pop()
      }
    }
    state.historyList = updateHistoryList
    // todo
    setStorage({ key: STORAGE_HISTORY_LIST, data: updateHistoryList })
  },

  /**
   * @method 存储历史城市列表
   */
  setCityHistoryList(state, payload) {
    const { city_id, city_name } = payload
    if (!city_id || !city_name) {
      return
    }
    let updateHistoryList = JSON.parse(JSON.stringify(state.cityHistoryList))
    const preCheck = updateHistoryList.find(
      item => item.city_id === city_id && item.city_name === city_name
    )

    if (preCheck) {
      updateHistoryList = updateHistoryList.filter(
        item => item.city_id !== city_id || item.city_name !== city_name
      )
      updateHistoryList.unshift(payload)
    } else {
      updateHistoryList.unshift(payload)
      if (updateHistoryList.length > 9) {
        updateHistoryList.pop()
      }
    }

    if (updateHistoryList.length > 8) {
      updateHistoryList = updateHistoryList.slice(0, 8)
    }

    state.cityHistoryList = updateHistoryList
    // todo
    setStorage({ key: STORAGE_CITY_HISTORY_LIST, data: updateHistoryList })
  },

  /**
   * @description: 存储城市列表
   */
  setAllTrainCityList(state, payload) {
    const { cities = [], hot_city_list = [] } = payload
    state.trainCities = cities
    state.trainHotCities = hot_city_list
  },

  setTravelType(state, payload) {
    state.travelType = payload
    setStorage({ key: STORAGE_TRAVEL_TYPE, data: payload })
  },

}
